export default __webpack_public_path__ + "static/media/Arrow_04.893efdec.svg";